import { render, staticRenderFns } from "./classAccount.vue?vue&type=template&id=1f4516df&scoped=true&"
import script from "./classAccount.vue?vue&type=script&lang=js&"
export * from "./classAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4516df",
  null
  
)

export default component.exports